import { Button } from '@chakra-ui/react';
import { ReactComponent as PreviewIcon } from 'assets/icons/toolbar/preview.svg';
import { DESIGN_PREVIEW, Mixpanel } from 'libs/third-party/Mixpanel';
import { useAppDispatch } from 'modules/Editor/store';
import { setIsPreviewModalOpen } from 'modules/Editor/store/editorSettingsSlice';
import { useTranslation } from 'react-i18next';

export const PreviewButton = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('common_navbar');
  const label = t('navbar.preview-button');

  const onPreviewClick = () => {
    dispatch(setIsPreviewModalOpen(true));
    Mixpanel.track(DESIGN_PREVIEW, { from: DESIGN_PREVIEW.from.settingsButton });
  };

  return (
    <Button
      leftIcon={<PreviewIcon />}
      onClick={onPreviewClick}
      fontWeight='medium'
      ml={4}
      mb={2}
      size='sm'
      variant='outline'
    >
      {label}
    </Button>
  );
};
